<template>
	<div class="my-table">
		<!-- 面包屑组件 -->
		<div class="searchBox flexCenter">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t('receiveShare.txt1')}}</span>
				<span>{{$t('receiveShare.txt2')}} / {{$t('receiveShare.txt3')}}</span>
			</div>
			<div class="flexEnd">
				<div class="searchBtn ml20" @click="saveToMe">{{$t('receiveShare.txt4')}}</div>
				<!-- <div class="searchBtn ml20" @click="handleDelete">{{$t('receiveShare.txt5')}}</div> -->
			</div>
		</div>
		<!-- 面包屑 -->
		<el-card class="tableCard">
			<el-table ref="table" :data="dataList" v-loading="loading" @selection-change="handleSelectionChange" @row-click="rowClick" >
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column :label="$t('receiveShare.txt6')">
					<template slot-scope="scope">
						<div class="flex align-center link">
							<span>
								<!-- <img :src="getRowImg(scope.row)" class="mr-10" width="30"/> -->
								{{getFileName(scope.row.fileVos)}}
							</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column :label="$t('receiveShare.txt7')" >
					<template slot-scope="scope">
						<span>{{scope.row.shareType == 1 ? $t('receiveShare.txt8') : $t('receiveShare.txt9')}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('myShare.txt19')">
					<template slot-scope="scope">
						<span>{{scope.row.shareUsername}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('receiveShare.txt10')">
					<template slot-scope="scope">
						<span>{{formatDate(scope.row.createTime)}}</span>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<script>
	import { formatDate } from "@/plugins/date.js";
	import { fileTypes, getFileSize } from "@/utils/index";
	export default {
		data() {
			return {
				isList: true,
				fileTypes,
				multipleSelection: [],
			//用于获取数据列表
			queryInfo: {
				cmptName: "",
				endCreateTm: "",
				pageNum: 1,
				pageSize: 10,
				productTmplCmptId: "",
				projName: "",
				spvTm: "",
				startCreateTm: "",
				submitterName: "",
				witnCde: "",
				witnType: "",
			},
			dataList: [],
			total: 0,
			loading: false,
		};
	},
	created() {
		if(!this.$route.query.id) {
			this.loadData();
		}
		this.checkShare();
	},
	methods: {
		getFileSize,
		formatDate(time) {
			var date = new Date(time);
			return formatDate(date, "yyyy-MM-dd hh:mm:ss");
		},
		getRowImg(row) {
			if(row.sharePaths && row.sharePaths.length > 1) {
				return this.fileTypes.wen
			}
			if(!row.sharePaths) return '';
			const type = this.getFileType(row.sharePaths[0].sharePathKey.path);
			if(!type) {
				return this.fileTypes.folder
			}
			// if(row.fileVos[0].directory) {
			// }
			let res = this.fileTypes[type];
			return res || this.fileTypes.default
		},
        getFileType(name) {
        	let arr = name.split(".");
        	return arr[arr.length - 1];
        },
        getFileName(list) {
			if(list && list.length == 1) {
				return list[0].path
			}else if(list && list.length>1){
				return list.map(item =>{
					return item.path
				}).join('、 ') +  this.$t('myShare.txt9')
			}else{
			}
		},
        async checkShare() {
        	const { id, verification } = this.$route.query;
        	if(id) {
        		try{
        			const { data: res } = await this.$http.post(`/share/link/${id}?password=${verification}`)
        			if(!res.success) {
        				return this.$message.error(res.message);
        			}
        			this.$message.success(this.$t('receiveShare.txt11'));
        			this.loadData();
        		}
        		catch(e) {
        			this.loadData();
        		}
        	}
        },
		// 数据加载(监理现场见证记录列表)
		async loadData() {
			this.loading = true;
			const { data: res } = await this.$http.post("/share/list?isMe=2");
			this.loading = false;
			if (!res.success) {
				return this.$message.error(res.message);
			}
			this.dataList = res.result || [];
		},
		rowClick(row) {
			this.$refs.table.toggleRowSelection(row);
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		getSelection() {
			return new Promise((resolve) => {
				if (this.isList) {
					if (this.multipleSelection && this.multipleSelection.length) {
						resolve(this.multipleSelection);
					} else {
						this.$message.warning(this.$t('myShare.txt10'));
					}
				} else {}
			});
		},
		async saveToMe() {
			const list = await this.getSelection();
			console.log(list,'list')
			const paths = []
			// list.forEach(item => {
			// 	paths.push({
			// 		path: item.sharePaths[0].sharePathKey.path,
			// 		shareId: item.shareUser.id
			// 	})
			// }) 
			// const {data: res} = await this.$http.post("/user/info/save/tome", paths)

			const {data: res} = await this.$http.post("/share/saveToMe", list)
			if (!res.success) {
				return this.$message.error(res.message);
			}			
			this.$message.success(res.message);
		},
		// 删除
		async handleDelete(row) {
			const list = await this.getSelection();
			this.$confirm('<p class="color666 fz14">'+this.$t('receiveShare.txt13')+'</p>', this.$t('myDoc.txt4'), {
				dangerouslyUseHTMLString: true,
				confirmButtonText:  this.$t('receiveShare.txt14'),
				cancelButtonText: this.$t('receiveShare.txt15'),
				type: 'warning',
				center: true,
			}).then(async e => {
				let promiseList = [];;
				list.forEach(item => {
					promiseList.push(this.$http.post( "/share/delete?id=" + item.id ))
				})
				Promise.all(promiseList).then(resList => {
					console.log(resList)
					this.$message.success( this.$t('receiveShare.txt16'))
					this.loadData();
				}).catch(e => {
					console.log(e)
				})
			})
		},
		// 填写见证记录
		handleAdd(type) {
			this.$router.push({ path: "/sceneRecordEdit" });
		},
		// 编辑
		handleEdit(row) {
			this.$router.push({
				path: "/sceneRecordEdit",
				query: { id: row.id },
			});
		},
		// 搜索
		handleSearch() {
			this.queryInfo.pageNum = 1;
			this.queryInfo.pageSize = 10;
			this.loadData();
		},
		// 重置
		handleReset() {
			this.queryInfo = {
				keyword: "",
				manufacturerName: "",
				mobile: "",
				pageIndex: 1,
				pageSize: 10,
				pageSorts: [
				{
					asc: true,
					column: "",
				},
				],
				projectName: "",
			};
			this.loadData();
		},
		// 编辑/详情
		handleDetail(row, type) {
			this.$router.push({
				path: "/sceneRecordDetail",
				query: { type: type, id: row.id },
			});
		},
		// 页面切换
		handleCurrentChange(pageNum) {
			this.queryInfo.pageNum = pageNum;
			this.loadData();
		},
		handleSizeChange(pageSize) {
			this.queryInfo.pageSize = pageSize;
			this.loadData();
		},
		// 监理现场见证记录-批量删除
		async delete(row) {
			const { data: res } = await this.$http.delete(
				"/dmp-es-admin/sms/smsWitnRec/deleteBatch?ids=" + row.id
				);
			if (res.code !== 200) {
				return this.$message.error(res.message);
			}
			this.$message({
				type: "success",
				message: "删除成功!",
			});
			this.loadData();
		},
	},
};
</script>

<style lang="less" scoped>
	.showType {
		font-size: 1.4rem;
		font-weight: 400;
		color: #1b3b7c;
		height: 30px;
		line-height: 30px;
		cursor: pointer;
	}
	.searchBox {
		.flex {
			position: absolute;
			right: 0;
		}
	}
	.selectAll {
		padding: 3.7rem 3rem 1.7rem 3rem;
		border-bottom: 1px solid #eee;
	}
	.latticeShow {
		ul {
		/*      .el-checkbox-group{
			display: flex;
		}*/
		li:hover {
			background: #dae4f9;
		}
		li {
			width: 18rem;
			height: 18rem;
			/*   margin-right: 4.2rem;
			margin-bottom: 4.2rem;*/
			float: left;
			padding: 1.1rem 1.1rem 1.9rem 1.1rem;
			cursor: pointer;
			border-radius: 10px;
			.el-checkbox {
				display: block;
			}
			img {
				display: block;
				margin: 0 auto;
				margin-top: 1.4rem;
				width: 8rem;
				height: 8rem;
			}
			p {
				margin-top: 2.6rem;
				font-size: 1.4rem;
				font-weight: 400;
				color: #333333;
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
}
</style>
